// @flow
import { graphql } from 'react-apollo';
import { getOr } from 'lodash/fp';
import gql from 'graphql-tag';

export default graphql(
  gql`
    query getFeed($page: Int!) {
      user {
        id
        proposals(page: $page) {
          id
          title
          createdAt
          isUpvoted
          totalUpvotes
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  `,
  {
    name: 'getFeed',
    props: ({ getFeed }) => ({
      feed: getOr([], 'user.proposals', getFeed),
      feedError: getOr(null, 'error', getFeed),
    }),
    options: {
      variables: {
        page: 0,
      },
    },
  }
);



// WEBPACK FOOTER //
// ./src/pages/feed/graphql/get-feed.js